export default __webpack_public_path__ + "static/media/illustrasi-line-dash-lamp.68b42747.svg";